// extracted by mini-css-extract-plugin
export default {"videoContainer":"Tickets_videoContainer__MwEoB","videoFrame":"Tickets_videoFrame__3cKpV"};